import { types, query, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';
import { Types } from '@blumtechgroup/blum-ui-utils';

const _editOrganisationUserInitQuery = (userId: string) => ({
  users_organisation_admin_by_pk: params(
    { id: rawString(userId) },
    {
      first_name: types.string,
      last_name: types.string,
      organisation: {
        name: types.string,
      },
    }
  ),
});

type X = Types.Unpacked<typeof _editOrganisationUserInitQuery>;
export type User = X['users_organisation_admin_by_pk'];

export const editOrganisationUserInitQuery = (userId: string) =>
  gql`
    ${query(_editOrganisationUserInitQuery(userId))}
  `;
